interface PostAuthRedirectContext {
  path: string;
  hash: string;
  host: string;
  hasExplicitLogin: boolean;
}

export const shouldRunPostAuthRedirect = ({
  path,
  hash,
  host,
  hasExplicitLogin,
}: PostAuthRedirectContext): boolean => {
  const isPublicMarketingHost =
    host === "retaillemon.com" || host === "www.retaillemon.com";
  const isOAuthReturn =
    hash.includes("access_token") || hash === "#" || path.startsWith("/auth/");

  return (
    hasExplicitLogin ||
    isOAuthReturn ||
    ((path === "/" || path === "") && !isPublicMarketingHost)
  );
};